import { useEffect } from "react";
import { format } from 'date-fns';
import { datadogLogs } from '@datadog/browser-logs';

const Test = () => {

  useEffect(() => {
    datadogLogs.logger.warn('Page Visited', { 
      name: 'Test',
      timestamp: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
      service: 'Restaurant Default',
      env: 'uat',
      version: '0.0.1',
      organisation: 'TYIMXJyrsby3hAf4Z1Wk',
      storeId: 'fm-generic',
    });
  }, [])

  return (
    <div>Test</div>
  );
}

export default Test;
